import { render, staticRenderFns } from "./QuotaStatus.vue?vue&type=template&id=61e08f98"
import script from "./QuotaStatus.vue?vue&type=script&lang=js"
export * from "./QuotaStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports